import React, {useState, useEffect} from 'react';
import Tabla from '../../../componentes/herramientas/tabla';
import {Ver_Valores, conexiones, genera_formulario, Moneda, Form_todos, Titulos_todos, ReporteExcell, ReporteExcellM} from '../../../constantes';
import Dialogo from '../../../componentes/herramientas/dialogo';
import IconButton from '@mui/material/IconButton';
import Esperar from '../../../componentes/esperar/cargar';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Reporte from '../../../componentes/reporte';
import Recibopdf from '../pagar/pdf/recibonuevo';
import Facturapdf from '../pagar/pdf/factura';
import { Abrir_Recibo } from '../funciones';
//Iconos
import AutorenewIcon from '@mui/icons-material/Autorenew';
import Icon from '@mui/material/Icon';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import Formulario from '../../../componentes/herramientas/formulario';
import Cargando from '../../../componentes/esperar/cargar';
import Scrollbars from '../../../componentes/herramientas/scrolbars';
import Prueba from '../../pruebas/puevaexc';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

function Recibo (props) {
    const {Config} = props;
    const {User} = Ver_Valores();
    // const estilos= Config && Config.Estilos.Usuarios ? Config.Estilos.Usuarios : Ver_Valores().config.Estilos.Usuarios ? Ver_Valores().config.Estilos.Usuarios : {} //props.config.Estilos.Usuarios ? props.config.Estilos.Usurios : {}
    // const classes= Estilos(estilos);
    const [state, setState]= useState({esperar:true});
    const [dialogo, setDialogo]= useState({
        open:false,  
    });
    
    let Formularios;
    let FInicio;
    let FFin;

    const Refrescar = ()=>{
        let formulario = state.formulario ? state.formulario : Formularios;
        FInicio= formulario.titulos[0].value.inicio.value;
        FFin = formulario.titulos[0].value.fin.value;
        Ver_data(FInicio, FFin, formulario)
    }

    const cambiarState = (nuevostate)=>{
        setState({...state, ...nuevostate, cambio:true})
    }
    const Actualizar_data = (valores)=>{
        cambiarState({cantidad:valores.cantidad, datos:valores.nuevodatos})
    }

    const Abrir_recibo = async(valores)=>{
        const {recibo}=valores.valores;
        // const resultado = Recibopdf(valores);
        // let Cuerpo= <embed src={`${resultado}#view=Fit&toolbar=1&navpanes=1&scrollbar=1`} type="application/pdf" width="100%" height={window.innerHeight * 0.75} />
        setDialogo({
            ...dialogo, 
            open: !dialogo.open,
            // tam:'xl',
            Titulo: `Recibo: ${recibo}`,
            Cuerpo: <Reporte  datos={valores} reporte={Recibopdf} sizePagina= {{width:612, height:396}} />,
            Cerrar: ()=>setDialogo({...dialogo,open:false}),
        })

    }

    const Abrir_factura = async(valores)=>{
        const {recibo}=valores.valores;
        const {recibo_facturar, inicio_factura, inicio_control}= Ver_Valores().config;
        let cant = parseInt(recibo);
        if (cant>=recibo_facturar){
            cant-= recibo_facturar;
            let representantep;
            let resultado = await conexiones.Leer_C(['uecla_Representante'],{uecla_Representante:{_id:valores.valores.representante._id}});
            valores.valores.representante.direccion = resultado.datos.uecla_Representante[0].valores.direccion
            valores.valores.representante.telefono = resultado.datos.uecla_Representante[0].valores.telefono_movil
            let total_exento=0;
            let meses= [];
            let efectivo=0;
            let efectivod=0;
            let pmovil=0;
            let transferencia=0;
            let debito=0;
            let ddebito="";
            let dtransferencia="";
            let dpmovil="";
            let nota="";
            let ultimo_mes="";
            let formapago="";
            for (var j=0; j<valores.valores.mensualidades.meses.length;j++){
                let cant=1;
                let mes = valores.valores.mensualidades.meses[j];
                if (mes.value!=="abono" && mes.value!=="abono_anterior"){
                    //para calcular la cantidad cuando no se colocaba la descripcion completa
                    // for (var k=j+1; k<valores.valores.mensualidades.meses.length; k++){
                    //     let mes1=valores.valores.mensualidades.meses[k];
                    //     if (mes.value===mes1.value){
                    //         cant+=1;
                    //     }
                    // }
                    total_exento+=cant*mes.monto;
                    meses=[...meses,{
                        ...mes,
                        cantidad:cant,
                        // descripcion: mes.value==='inscripcion' 
                        //     ? `INSCRIPCION ESCOLAR AÑO ${mes.periodo} (E)`
                        //     : `MENSUALIDAD ${mes.value.toUpperCase()} ${mes.periodo} (E)`,
                        descripcion:`${mes.descripcion} (E)`,
                        precio:mes.monto,
                        monto: cant*mes.monto,
                        id:meses.length+1,

                    }]
                    ultimo_mes= mes.value//.toUpperCase();
                }else if (mes.value==="abono" && (Number(Number(mes.monto).toFixed(2))!==0 || Number(Number(mes.montod).toFixed(2))!==0)){
                    const lista = Ver_Valores().config.Listas.lista_Meses;
                    const pos = lista.findIndex(f=> f.value===ultimo_mes);
                    
                    if (pos!==-1){
                        nota=`Nota: "Anticipo por el mes de ${lista[pos!==12 ? pos+1 : 0].value.toUpperCase()}"`;
                    }else{
                        nota=`Nota: "Anticipo por el mes de ${ultimo_mes.toUpperCase()}"`;
                    }
                    
                    
                }
            }
            valores.valores.Formas_pago.map(val=>{
                if (val.value==="transferencia"){
                    transferencia+=Number(val.monto);
                    dtransferencia+= dtransferencia ==="" ? val.bancod : `, ${val.bancod}`;
                    formapago+= formapago==="" ? `Transferencia (${val.bancod} ref.: ${val.referencia})` : `, Transferencia (${val.bancod} ref.: ${val.referencia})`;
                }else if (val.value==="pagomovil"){
                    pmovil+=Number(val.monto);
                    console.log(val.bancod);
                    dpmovil+= dpmovil ==="" ? val.bancod : `, ${val.bancod}`;
                    formapago+= formapago==="" ? `Pago Movil (${val.bancod} ref.: ${val.referencia})` : `, P.Movil (${val.bancod} ref.: ${val.referencia})`;
                }else if (val.value==="efectivo"){
                    efectivo+=Number(val.monto);
                    formapago+= formapago==="" ? `Efecitvo (${val.bancod})` : `, Efectivo (${val.bancod})`;
                }else if (val.value==="debito"){
                    debito+=Number(val.monto);
                    ddebito+= ddebito ==="" ? val.bancod : `, ${val.bancod}`;
                    formapago+= formapago==="" ? `T. Débito (${val.bancod} ref.: ${val.referencia})` : `, T. Débito (${val.bancod} ref.: ${val.referencia})`;
                }else if (val.moneda==="$"){
                    efectivod+=Number(val.monto);
                    formapago+= formapago==="" ? `Dolar (${val.bancod})` : `, Dolar (${val.bancod})`;
                }
                return val
            })
            console.log(meses);
            console.log(valores.valores);
            valores.valores.mensualidadesF={meses}
            valores.valores.total_exento=total_exento;
            valores.valores.efectivo=efectivo;
            valores.valores.efectivod=efectivod;
            valores.valores.debito=debito;
            valores.valores.ddebito=ddebito;
            valores.valores.transferencia=transferencia;
            valores.valores.dtransferencia=dtransferencia;
            valores.valores.pmovil=pmovil;
            valores.valores.dpmovil=dpmovil;
            valores.valores.nota=nota;
            valores.valores.notapago=formapago;
            
            if (resultado.datos.uecla_Representante[0].representante_pago && resultado.datos.uecla_Representante[0].representante_pago.value==="no"){
                representantep={
                    nombres: resultado.datos.uecla_Representante[0].rp_nombres,
                    apellidos: resultado.datos.uecla_Representante[0].rp_apellidos,
                    cedula: resultado.datos.uecla_Representante[0].rp_cedula,
                    direccion: resultado.datos.uecla_Representante[0].rp_direccion,
                    telefono: resultado.datos.uecla_Representante[0].rp_telefono,
                }
                console.log(representantep)
            }
            //let resultado = await conexiones.Leer_C(['uecla_Estudiante'],{uecla_Estudiante:{}});
            setDialogo({
                ...dialogo, 
                open: !dialogo.open,
                // tam:'xl',
                Titulo: `Factura: ${String(inicio_factura + cant).padStart(8, '0')} - N° Control: ${String(inicio_control + cant).padStart(8, '0')}`,
                Cuerpo: <Reporte  datos={{...valores, factura:inicio_factura + cant, control: inicio_control + cant, representantep}} reporte={Facturapdf} sizePagina= {{width:612, height:396}} />,
                Cerrar: ()=>setDialogo({...dialogo,open:false}),
            })

        }else{
            setDialogo({
                ...dialogo, 
                open: !dialogo.open,
                // tam:'xl',
                Titulo: `Factura no encontrada`,
                Cuerpo: <div>Sin factura asociada en el sistema</div>,
                Cerrar: ()=>setDialogo({...dialogo,open:false}),
            })    
        }

    }

    const ReporteM = () =>{
        ReporteExcell(state.datos,state.inicio, state.fin, `${moment(state.inicio).format('DD-MM-YYYY')} al ${moment(state.fin).format('DD-MM-YYYY')}`,`Reporte${moment(state.inicio).format('DD-MM-YYYY')}al${moment(state.fin).format('DD-MM-YYYY')}.xlsm`)
        // let formulario = state.formulario ? state.formulario : Formularios;
        // FInicio= formulario.titulos[0].value.inicio.value;
        // FFin = formulario.titulos[0].value.fin.value;
        // console.log(FInicio, FFin)
        // setDialogo({
        //     ...dialogo, 
        //     open: !dialogo.open,
        //     Titulo: `Reporte ${moment(FInicio).format('DD/MM/YYYY')} - ${moment(FFin).format('DD/MM/YYYY')}`,
        //     tam:'xl',
        //     Cuerpo: <Prueba Datos={state.datos} Inicio={FInicio} Fin={FFin}/>,
        //     Cerrar: ()=>setDialogo({...dialogo,open:false}),
        // })
    }

    const ReporteP = () =>{
        let formulario = state.formulario ? state.formulario : Formularios;
        FInicio= formulario.titulos[0].value.inicio.value;
        FFin = formulario.titulos[0].value.fin.value;
        console.log(FInicio, FFin)
        setDialogo({
            ...dialogo, 
            open: !dialogo.open,
            Titulo: `Reporte ${moment(FInicio).format('DD/MM/YYYY')} - ${moment(FFin).format('DD/MM/YYYY')}`,
            tam:'xl',
            Cuerpo: <Prueba Datos={state.datos} Inicio={FInicio} Fin={FFin}/>,
            Cerrar: ()=>setDialogo({...dialogo,open:false}),
        })
    }
    const Abrir = async(valores) =>{
        const resultado= await Abrir_Recibo(valores, Abrir_recibo, Abrir_factura);
        // const {mensualidades, Formas_pago, recibo, subtotalvalor, totales}=valores.valores
        // let Fmensualidad = await genera_formulario({valores:mensualidades, campos: Form_todos('Form_Mensualidades') })
        // Fmensualidad.titulos.meses.noeliminar=true;
        // Fmensualidad.titulos.meses.nopaginar=true;
        // Fmensualidad.titulos.meses.label='Pagos a Realizados';
        // Fmensualidad.titulos.meses.style={height:320};
        // let nuevos = Formas_pago.map((val, i)=>{
        //     return {...val,
        //         id:i+1, 
        //         formapago: val.titulo, bancoorigen: val.bancoorigen ? val.bancoorigen : '', 
        //         bancodestino: val.bancodestino ? val.bancodestino : '',
        //         fecha: val.fecha===null ? '' : typeof val.fecha==='string' ? val.fecha : moment(val.fecha).format('DD/MM/YYYY')
        //     }
        // })

        // let Formapago = await genera_formulario({valores:{formapago:nuevos}, campos: Form_todos('Form_FormasPago') })
        // Formapago.titulos.formapago.noeliminar=true;
        // Formapago.titulos.formapago.nopaginar=true;
        // Formapago.titulos.formapago.Form=undefined;
        // Formapago.titulos.formapago.Subtotal=undefined;
        // Formapago.titulos.formapago.editables='no';
        // Formapago.titulos.formapago.style={height:250}; 

        // let Cuerpo =
        // <Box sx={{ textAlign:'left' }}>
        //     <div style={{marginTop:-30}}/>
            
        //     <Formulario {...Fmensualidad}/>
        //     <div style={{marginTop:-30}}/>
            
        //     <Formulario {...Formapago}/>
                
        //     <div style={{ paddingRight:10}}>
        //         <Stack
        //             direction={ 'column' }
        //             spacing={1}
        //             justifyContent="center"
        //             alignItems="flex-end"
        //         >
        //             <Typography variant="h5" gutterBottom component="div">
        //                 Total : {`${Moneda(subtotalvalor.total) }`}
        //             </Typography>
        //             <Typography variant="h5" gutterBottom component="div">
        //                 Total Cancelado: {`${Moneda(totales.total)}`}
        //             </Typography>
        //             <Typography variant="h5" >
        //                 Abono: {`${Moneda(totales.abono)}`}
        //             </Typography>
                
                    
        //         </Stack>
        //     </div>
        // </Box>

        // let Titulo = 
        //         <Stack
        //             direction={ 'row' }
        //             spacing={1}
        //             justifyContent="center" alignItems="center"
        //         >
        //             Recibo: {recibo}
        //             <IconButton size="large" color="inherit" title={'Mostra recibo'} onClick={()=>Abrir_recibo(valores)}>
        //                 <Icon >text_snippet</Icon>
        //             </IconButton>
        //         </Stack>
        
        setDialogo({
            ...dialogo, 
            open: !dialogo.open,
            Titulo: resultado.Titulo,
            Cuerpo: resultado.Cuerpo,
            Cerrar: ()=>setDialogo({...dialogo,open:false}),
        })
    }
    
    const Ver_data = async(inicio= new Date(), fin= new Date(), formulario=null)=>{
        cambiarState({esperar:true});
        // inicio.setHours(0,0,0,1);
        // fin.setHours(23,59,59,999);
        // inicio=moment(inicio).format('YYYY-MM-DD');
        // fin=moment(fin).format('YYYY-MM-DD');
        let respuesta= await conexiones.Recibo({inicio,fin});
        // Leer_C(['uecla_Recibo'], 
        //     {
        //         'uecla_Recibo':Ver_Valores().tipo==='Electron' ? {} : {$or: [{'fecha':{$gte: inicio, $lte: fin}}]} //{createdAt: {$gte: inicio, $lte: fin}},
        //     }
    
        // );

        if (respuesta.Respuesta==='Ok'){
            
            let datos =respuesta.recibos
                // .filter(f=> moment(f.valores.sistema_viejo ? f.valores.fecha : f.createdAt).format('YYYY-MM-DD')>=moment(inicio).format('YYYY-MM-DD') && moment(f.valores.sistema_viejo ? f.valores.fecha : f.createdAt).format('YYYY-MM-DD')<=moment(fin).format('YYYY-MM-DD'))
                .map(val=>{
                    if (val.valores.sistema_viejo){
                        return {...val, createdAt: val.valores.fecha}
                    }else{
                        return val
                    }
                })
                // .sort((a,b) => Number(a.recibo)> Number(b.recibo) ?  1 : -1);
            if ([4,'4'].indexOf(User.categoria)!==-1){
                datos= datos.filter(f=> String(f.valores.representante._id).toLowerCase()===String(User.valores._id).toLowerCase() || f.valores.representante.cedula===User.valores.cedula)
            }
            let totales = {total:0, pagomovil:0, transferencia:0, efectivo:0, dolar:0, debito:0, credito:0, zelle:0};
            datos.map(val=>{
                totales.total+=val.valores.totales.total;
                val.valores.Formas_pago.map(pa=>{
                    if (pa.value==='transferencia'){
                        totales.transferencia+=Number(pa.monto)
                    }else if (pa.value==='debito'){
                        totales.debito+=Number(pa.monto)
                    }else if (pa.value==='credito'){
                        totales.credito+=Number(pa.monto)
                    }else if (pa.value==='pagomovil'){
                        totales.pagomovil+=Number(pa.monto)
                    }else if (pa.value==='efectivobolivar'){
                        totales.efectivo+=Number(pa.monto)
                    }else if (pa.value==='efectivodolar'){
                        totales.dolar+=Number(pa.monto)
                    }
                    else if (pa.value==='zelle'){
                        totales.zelle+=Number(pa.monto)
                    }
                    return pa
                })
                return val
            })
            if (formulario!==null){
                cambiarState({inicio, fin, datos, esperar:false, formulario, totales})
                Formularios= formulario
            }else{
                cambiarState({datos, esperar:false, totales})
            }
        }else{
            cambiarState({esperar:false});
            confirmAlert({
              title: respuesta.mensaje,
              buttons: [
                {label: 'Continuar'},
                {label: 'Reintentar', onClick: ()=>Ver_Valores(inicio, fin, formulario)}
              ]
            });
        }


    }
    const Cambio_fecha = async (valores)=>{
        const {inicio, fin}=valores.resultados;
        let formulario = state.formulario ? state.formulario : Formularios;
        if (inicio<=fin){
            FFin= fin;
            FInicio = inicio;
            formulario.titulos[0].value.inicio.onChange= Cambio_fecha;
            formulario.titulos[0].value.fin.onChange= Cambio_fecha;
            formulario.titulos[0].value.inicio.value= inicio;
            formulario.titulos[0].value.fin.value= fin;
            Ver_data(inicio, fin, formulario)
            
        }else{
            cambiarState({formulario})
        }
        
        
    }
    const Inicio = async() =>{
        FInicio= new Date();
        FFin = new Date();
        let formulario = await genera_formulario({valores:{inicio: FInicio, fin: FFin}, campos: Form_todos('Form_fecha_recibo') })
        formulario.titulos[0].value.inicio.onChange= Cambio_fecha;
        formulario.titulos[0].value.fin.onChange= Cambio_fecha;
        // FInicio.setHours(0,0,0,1);
        // FFin.setHours(23,59,59,999)
        cambiarState({formulario})
        
        Ver_data(FInicio, FFin, formulario)
        // Ver_data()
    }
    const Inicio1 = async() =>{
        const titulos = await Titulos_todos(`Titulos_Recibo`, Config)
        cambiarState({ titulos})
        
    }
   
    useEffect(()=>{
        Inicio()
        return ()=>{
            
        }
    }, [props])
    if (!state.titulos){
        Inicio1();
    }
    
    const color =  props.Config.Estilos.Input_icono_t ? props.Config.Estilos.Input_icono_t : {};
    const alto = Ver_Valores().tipo==='Web' 
        ?   window.innerHeight * 0.65
        :   window.innerHeight * 0.68
    return state.esperar ? <Cargando open={state.esperar} Config={Config}/> 
        :!state.titulos? null: (
        <div >
            <Tabla  Titulo={"Recibos"}
                    alto={alto}
                    Config={Config ? Config : Ver_Valores().config}
                    titulos={state.titulos}
                    table={'uecla_Recibo'}
                    cantidad={state.cantidad ? state.cantidad : null}
                    cargacompleta={Actualizar_data}
                    datos={state.datos}
                    Accion={Abrir}
                    Noactualizar
                    cargaporparte={true}
                    sinpaginacion={true}
                    acciones={
                        <Stack direction="row" spacing={1}>
                            <IconButton color={'primary'} title={'Refrescar valores de Recibos'} onClick={Refrescar}>
                                <AutorenewIcon style={color}/>
                            </IconButton>
                            <IconButton color={'primary'} title={'Reporte'} onClick={ReporteM}>
                            <Icon style={color}>assignment</Icon>
                            </IconButton>
                            {/* <IconButton color={'primary'} title={'Reporte'} onClick={ReporteP}>
                            <Icon style={color}>assignment</Icon>
                            </IconButton> */}
                            {state.formulario 
                                ?   <Box sx={{width:window.innerWidth * 0.5}}>
                                        <Scrollbars sx={{ flexGrow: 1, width:window.innerWidth * 0.4, overflow:'auto' ,display: { xs: 'flex', md: 'flex' } }}>
                                            <Formulario {...state.formulario} 
                                                        config={{...Ver_Valores().config,
                                                            Estilos:{
                                                                Input_label:{color:'#fff'}
                                                            }
                                                        }}
                                            /> 
                                        </Scrollbars>
                                    </Box>
                                : null}
                        </Stack>
                    }
                    acciones1={
                        [4,'4'].indexOf(User.categoria)===-1 
                        ?   <Scrollbars sx={{ justifyContent:window.innerWidth > 750 ? "flex-end" : "", flexGrow: 1, width:window.innerWidth > 750 ? window.innerWidth * 0.97: '100%', overflow:'auto' ,display: { xs: 'flex', md: 'flex' } }}>
                            <Stack
                                direction="row"
                                divider={<Divider orientation="vertical" flexItem />}
                                spacing={1}
                                justifyContent="flex-end"
                                alignItems="center"
                            >
                                <Item title={`Total obtenido por efectivo en dolar en fecha indicada`}>Dolar: $ {state.totales ? Moneda(state.totales.dolar,'$',false) : 0 }</Item>
                                <Item title={`Total obtenido por efectivo en dolar en fecha indicada`}>zelle: $ {state.totales ? Moneda(state.totales.zelle,'$',false) : 0 }</Item>
                                <Item title={`Total obtenido por efectivo en Bolivares en fecha indicada`}>Efectivo: Bs. {state.totales ? Moneda(state.totales.efectivo,'Bs', false) : 0 }</Item>
                                <Item title={`Total obtenido por debito en fecha indicada`}>Debito: Bs. {state.totales ? Moneda(state.totales.debito,'Bs',false) : 0 } </Item>
                                <Item title={`Total obtenido por credito en fecha indicada`}>Credito: Bs. {state.totales ? Moneda(state.totales.credito,'Bs',false) : 0 } </Item>
                                <Item title={`Total obtenido por transferencia en fecha indicada`}>Transferencia: Bs. {state.totales ? Moneda(state.totales.transferencia,'Bs',false) : 0 }</Item>
                                <Item title={`Total obtenido por pago movil en fecha indicada`}>Pago Movil: Bs. {state.totales ? Moneda(state.totales.pagomovil,'Bs',false) : 0 }</Item>
                                <Item title={`Total facturado en fecha indicada`}>Facturado: Bs. {state.totales ? Moneda(state.totales.total,'Bs',false) : 0 }</Item>
                            </Stack>
                            </Scrollbars>
                        : null
                    }
            />
            <Dialogo  {...dialogo} config={Ver_Valores().config}/>
            <Esperar open={state.esperar}/>
        
        </div>
    )
}

export default Recibo;